import { render } from "./AddContactModal.vue?vue&type=template&id=d82b6498&ts=true"
import script from "./AddContactModal.vue?vue&type=script&lang=ts"
export * from "./AddContactModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__